<template>
  <div class="modal-component-header">
    <h2 class="modal-create-modal-title">
      <slot />
    </h2>
    <!--    <span class="modal-component-header-close" @click="handlerClose">-->
    <!--      <svg class="modal-component-header-icon"><use xlink:href="#svg-close"></use></svg>-->
    <!--    </span>-->
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.modal-component-header {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-grey);
  min-height: 48px;
  @include point-md {
    padding: 12px 24px;
  }
}
.modal-create-modal-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 125%; /* 20px */
  text-transform: uppercase;
  margin-right: 40px;
  margin-bottom: 0;
  @include point-md {
    font-size: 18px;
  }
}
</style>
